import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { IonicSelectableComponent } from 'ionic-selectable';
import { MyService } from '../../service/my.service';
@Component({
  selector: 'app-setup-membership',
  templateUrl: './setup-membership.component.html',
  styleUrls: ['./setup-membership.component.scss'],
})
export class SetupMembershipComponent implements OnInit {

  @Input() setupValue: any;
  @Input() setupValueType: any;
  @Input() setupName:any;
  @Input() description: any;
  @Input() id: number;
  @Input() formType:any;
  @Input() notifTime:any;
  @Input() timeType:any;
  @Input() timing:any;
  isReadonly = false;
  constructor(
    private modalController : ModalController,
    private myService:MyService,
    private alertController :AlertController
  ) { }

  ngOnInit() {
  }
  async dismissModal(type:any) {
    let error = 0;
    let errorMessage = '';
    if(type=='s'){
      if(this.formType=='point'){
        if(this.setupName!='show_referral_code' && (this.setupValue==0 || this.setupValue=='' || this.setupValue==undefined)){
          errorMessage += 'setup value harus diisi<br>';
          error++;
        }
        if(this.description==''  || this.description==undefined){
          errorMessage += 'Description harus diisi<br>';
          error++;
        }
        if(error!=0){
          this.showAlert(errorMessage);
        }
        else{
          let close: any[] = [];
          let productData = {
            setupValue: this.setupValue,
            setupValueType: this.setupValueType,
            description: this.description
          };
          close.push(productData);
          await this.modalController.dismiss(productData);
        }
      }
      else if(this.formType=='reminder'){
        if(this.timing!='otd' && (this.notifTime==0 || this.notifTime=='' || this.notifTime==undefined)){
          errorMessage += 'setup value harus diisi<br>';
          error++;
        }
        if(this.timing !='otd' && (this.timeType==''  || this.timeType==undefined)){
          errorMessage += 'Day/Month/Year harus dipilih<br>';
          error++;
        }
        if(this.timing==''  || this.timing==undefined){
          errorMessage += 'Before/On the Day /After harus dipilih<br>';
          error++;
        }
        if(error!=0){
          this.showAlert(errorMessage);
        }
        else{
          let close: any[] = [];
          let productData = {
            timeType:this.timing==0 ?'day': this.timeType,
            notifTime: this.timing==0 ? 0 : this.notifTime,
            timing:this.timing
          };
          close.push(productData);
          await this.modalController.dismiss(productData);
        }
      }
    }
    else{
        await this.modalController.dismiss('');
      }
  }
  
  async showAlert(message: any) {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: message,
      backdropDismiss: true,
      buttons: [
        {
          text: 'OK',
          handler: () => {
          }
        }
      ]
    });
    await alert.present();
  }
  onChangeInput(){
    let curWithSeparator = this.myService.separator(this.setupValue);
    curWithSeparator = String(curWithSeparator).replace(/[^0-9,]/g, '');
    this.setupValue = curWithSeparator;
  }
  numberOnlyValidation(event: any) {
    const pattern = /[0-9.,]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
